const userTokenKey = 'user_token'
const adminTokenKey = 'admin_token'
const userRefreshTokenKey = 'user_refresh_token'
const adminRefreshTokenKey = 'admin_refresh_token'
const userSessionSourceKey = 'user_session_source'
const adminSessionSourceKey = 'admin_session_source'

export type PortalKind = 'user' | 'admin'
export type PortalSessionSource = 'password' | 'sso'

/**
 * access token key 是新前端与旧前端、后端跳转之间的 contract。
 * 前台和后台必须分开存储，避免两个门户的会话互相覆盖。
 */
export function getStoredToken(portal: PortalKind) {
  return window.localStorage.getItem(portal === 'admin' ? adminTokenKey : userTokenKey)
}

export function setStoredToken(portal: PortalKind, token: string) {
  window.localStorage.setItem(portal === 'admin' ? adminTokenKey : userTokenKey, token)
}

export function clearStoredToken(portal: PortalKind) {
  window.localStorage.removeItem(portal === 'admin' ? adminTokenKey : userTokenKey)
}

/**
 * refresh token 与 access token 同样按门户隔离。
 * refresh 流程会依赖 token 轮换来判断其他标签页是否已经刷新成功。
 */
export function getStoredRefreshToken(portal: PortalKind) {
  return window.localStorage.getItem(
    portal === 'admin' ? adminRefreshTokenKey : userRefreshTokenKey,
  )
}

export function setStoredRefreshToken(portal: PortalKind, token: string) {
  window.localStorage.setItem(
    portal === 'admin' ? adminRefreshTokenKey : userRefreshTokenKey,
    token,
  )
}

export function clearStoredRefreshToken(portal: PortalKind) {
  window.localStorage.removeItem(portal === 'admin' ? adminRefreshTokenKey : userRefreshTokenKey)
}

export function getStoredSessionSource(portal: PortalKind): PortalSessionSource {
  const value = window.localStorage.getItem(
    portal === 'admin' ? adminSessionSourceKey : userSessionSourceKey,
  )

  return value === 'sso' ? 'sso' : 'password'
}

export function setStoredSessionSource(portal: PortalKind, source: PortalSessionSource) {
  window.localStorage.setItem(
    portal === 'admin' ? adminSessionSourceKey : userSessionSourceKey,
    source,
  )
}

export function clearStoredSessionSource(portal: PortalKind) {
  window.localStorage.removeItem(portal === 'admin' ? adminSessionSourceKey : userSessionSourceKey)
}
